/**
 * Kertox Advertorial - Women 50 Plus
 * Behaviour preserved exactly from the approved reference build:
 *  - top scroll progress bar
 *  - bottom sticky bar shown after a scroll offset
 *  - front-end countdown timer (fixed UTC deadline, defined in section settings)
 *  - scroll reveal animation via IntersectionObserver, respecting prefers-reduced-motion
 */
(function () {
  'use strict';

  function two(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function initSection(sectionId) {
    var root = document.querySelector('.kertox-advertorial[data-section-id="' + sectionId + '"]');
    if (!root || root.dataset.kertoxInitialized === 'true') {
      return;
    }
    root.dataset.kertoxInitialized = 'true';

    var progressBar = document.getElementById('progress-' + sectionId);
    var stickyBar = document.getElementById('kertox-stickybar-' + sectionId);
    var stickyOffset = stickyBar ? parseInt(stickyBar.getAttribute('data-show-after'), 10) || 600 : 600;

    function onScroll() {
      if (!progressBar) return;
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      var p = max > 0 ? (doc.scrollTop || document.body.scrollTop) / max * 100 : 0;
      progressBar.style.width = p + '%';
    }

    function stickyToggle() {
      if (!stickyBar) return;
      if (window.scrollY > stickyOffset) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    document.addEventListener(
      'scroll',
      function () {
        onScroll();
        stickyToggle();
      },
      { passive: true }
    );
    onScroll();
    stickyToggle();

    // Countdown timer: persists end-time in localStorage so return visits resume
    // from where they left off. Auto-resets to 24 h when expired.
    // Broadcasts kertox:countdown:tick every second so the sticky bar mirrors
    // the value with zero extra timers.
    var STORAGE_KEY = 'kertox_cd_end_' + sectionId;
    var countdownEl = root.querySelector('[data-hours-init]');
    if (countdownEl) {
      var cdH = countdownEl.querySelector('[data-cd-hours]');
      var cdM = countdownEl.querySelector('[data-cd-mins]');
      var cdS = countdownEl.querySelector('[data-cd-secs]');

      var saved = null;
      try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}

      var endTime;
      if (saved) {
        endTime = new Date(saved);
        if (endTime <= new Date()) {
          endTime = new Date(Date.now() + 24 * 3600000);
          try { localStorage.setItem(STORAGE_KEY, endTime.toISOString()); } catch (e) {}
        }
      } else {
        var hInit = parseInt(countdownEl.getAttribute('data-hours-init') || '11', 10);
        var mInit = parseInt(countdownEl.getAttribute('data-mins-init')  || '59', 10);
        var sInit = parseInt(countdownEl.getAttribute('data-secs-init')  || '59', 10);
        var durMs = ((hInit * 60 + mInit) * 60 + sInit) * 1000;
        endTime = new Date(Date.now() + durMs);
        try { localStorage.setItem(STORAGE_KEY, endTime.toISOString()); } catch (e) {}
      }

      function tickCountdown() {
        var diff = endTime - Date.now();
        if (diff <= 0) {
          endTime = new Date(Date.now() + 24 * 3600000);
          try { localStorage.setItem(STORAGE_KEY, endTime.toISOString()); } catch (e) {}
          diff = endTime - Date.now();
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (cdH) { cdH.textContent = two(h); }
        if (cdM) { cdM.textContent = two(m); }
        if (cdS) { cdS.textContent = two(s); }
        // Broadcast to sticky bar — listens for this event
        document.dispatchEvent(new CustomEvent('kertox:countdown:tick', {
          detail: { h: h, m: m, s: s }
        }));
      }
      tickCountdown();
      setInterval(tickCountdown, 1000);
    }

    // Sticky bar mirrors countdown via the broadcast event — no extra timer needed.
    var sbTimer = stickyBar ? stickyBar.querySelector('[data-sticky-timer]') : null;
    if (sbTimer) {
      document.addEventListener('kertox:countdown:tick', function (e) {
        sbTimer.textContent = two(e.detail.h) + ':' + two(e.detail.m) + ':' + two(e.detail.s);
      });
    }

    // Reveal on scroll.
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealEls = root.querySelectorAll('.kertox-advertorial__reveal');
    if ('IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-in');
      });
    }
  }

  window.KertoxAdvertorial = window.KertoxAdvertorial || {};
  window.KertoxAdvertorial.init = initSection;
})();